import {getRandomInt, shuffleArray} from "../util/util";
import {change, touch} from "redux-form";

export const generateProjectPassword = (formIdentifier) => (dispatch, getState) => {

    let generatedPasswordChars = [];

    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz'
    const digits = '0123456789';
    const special = '$!#*+,-.;_:/';
    const random = uppercaseChars + lowercaseChars + digits + special;

    // 20 chars, 4 : upper case, lower case, digit, special 16 : random
    generatedPasswordChars.push(uppercaseChars.charAt(getRandomInt(uppercaseChars.length - 1)));
    generatedPasswordChars.push(lowercaseChars.charAt(getRandomInt(lowercaseChars.length - 1)));
    generatedPasswordChars.push(digits.charAt(getRandomInt(digits.length - 1)));
    generatedPasswordChars.push(special.charAt(getRandomInt(special.length - 1)));

    for (let i = 0; i < 16; i++) {
        generatedPasswordChars.push(random.charAt(getRandomInt(random.length - 1)));
    }

    let generatedPassword = shuffleArray(generatedPasswordChars).join('');

    if(generatedPassword[0] === '-') {
        generatedPassword = '.'  + generatedPassword.slice(1);
    }

    // temporarily set a valid password so that the hint stays visible
    dispatch(change(formIdentifier, 'projectPassword', 'Abcabc123!'));
    dispatch(change(formIdentifier, 'projectPasswordRepeat', 'Abcabc123!'));

    setTimeout(() => {
        dispatch(change(formIdentifier, 'projectPassword', generatedPassword));
        dispatch(change(formIdentifier, 'projectPasswordRepeat', generatedPassword));
        dispatch(touch(formIdentifier, 'projectPassword', 'projectPasswordRepeat'));
    }, 25);
}



/** WEBPACK FOOTER **
 ** ./src/actions/Password.js
 **/